/**
 * Master switch for the user-facing Document Center: the Documents dashboard
 * page and its sidebar link, the in-sheet Documents panel and its sidebar
 * button, the docked dashboard document viewer, the public document share
 * route, and the Documents section of "Recover deleted files".
 *
 * Everything underneath stays wired up while this is off — documents are still
 * created by drag-and-drop, the Import menu, and AI chat attachments; the AI
 * document tools still read them; drive images still render in the grid. Only
 * the browsing/management surfaces are hidden.
 *
 * Flip to `true` to restore the UI.
 */
export const SHOW_DOCUMENT_CENTER_UI: boolean = false;
